import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Ourfocus(props) {
  return (
    <div className="tekrevol_ourforce p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="ERP Software">
              <h2>Perks Of Custom ERP Software Development</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              You can experience improved business operations with custom ERP
              solutions from our expert ERP developers.
            </p>
            <p>
              As a reputable ERP development company, we ensure the seamless
              integration of ERP software in your existing system and minimize
              disruptions to ongoing operations.
            </p>
            <p>
              You may combine business operations and functions into a single
              system with custom ERP software development.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Ourfocus;
